var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SkeletonPage, Layout, Form, FormLayout, LegacyCard, SkeletonBodyText, TextContainer, SkeletonDisplayText, Page, Box, Card, Text, TextField, Button, InlineStack } from '@shopify/polaris';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
;
var Home = function () {
    var _a = useState({
        is_loading: true,
        shop: '',
        code: '',
        hmac: '',
        timestamp: '',
        host: '',
        access_key: '',
        is_installed: 0
    }), data = _a[0], setData = _a[1];
    var navigate = useNavigate();
    /*
    ** Initiate variables from url parameters and local storage
    */
    useEffect(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var shop = urlParams.get('shop') || '';
        var is_loading = (shop != '' ? true : false);
        var code = urlParams.get('code') || '';
        var hmac = urlParams.get('hmac') || '';
        var timestamp = urlParams.get('timestamp') || '';
        var host = urlParams.get('host') || '';
        var is_installed = parseInt(urlParams.get('is_installed') || '0', 10);
        // Retrieve access_key from localStorage or similar storage
        var access_key = shop ? Cookies.get("access_key_".concat(shop)) || '' : '';
        // Set state with extracted values
        setData({
            is_loading: is_loading,
            shop: shop,
            code: code,
            hmac: hmac,
            timestamp: timestamp,
            host: host,
            access_key: access_key,
            is_installed: is_installed
        });
    }, []);
    /*
    ** Get access token if code and hmac parameters exists in the url
    */
    useEffect(function () {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('code') != '' && urlParams.get('code') != null) {
            getAccessToken();
        }
        else if (urlParams.get('shop') != null && urlParams.get('shop') != '' && urlParams.get('code') == null) {
            getShop();
        }
    }, [data]);
    var getShop = function () {
        handleInstallApp();
    };
    var handleInstallApp = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // Add your installation logic here
            fetch(App.api_base + '/get_installation_url', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Vuedoo-Domain': App.domain,
                    'X-Vuedoo-Access-Key': ''
                },
                body: JSON.stringify({ shop: data.shop })
            })
                .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse JSON response
            })
                .then(function (res) {
                if (res.status === 'success') {
                    if (window.top != null)
                        window.top.location.href = res.installation_url + '&redirect_uri=' + App.base;
                    else
                        window.location.href = res.installation_url + '&redirect_uri=' + App.base;
                }
            })
                .catch(function (error) {
                console.error('Error:', error);
            });
            return [2 /*return*/];
        });
    }); };
    var getAccessToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            fetch(App.api_base + '/get_access_token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Vuedoo-Domain': App.domain,
                    'X-Vuedoo-Access-Key': '',
                },
                body: JSON.stringify({
                    shop: data.shop,
                    code: data.code,
                    hmac: data.hmac,
                    timestamp: data.timestamp,
                    host: data.host,
                }),
            })
                .then(function (response) { return response.json(); }) // Parse the response as JSON
                .then(function (data) {
                if (data.status === 'success') {
                    localStorage.setItem("access_key_".concat(data.shop), data.access_key);
                    Cookies.set("access_key_".concat(data.shop), data.access_key, {
                        secure: true, // Only over HTTPS
                        sameSite: 'None', // Supports cross-origin iframe contexts
                        path: '/', // Available site-wide
                    });
                    navigate("/dashboard?shop=".concat(encodeURIComponent(data.shop)));
                }
            })
                .catch(function (error) {
                console.error(error);
            });
            return [2 /*return*/];
        });
    }); };
    return data.is_loading ? (_jsx(SkeletonPage, { primaryAction: true, children: _jsx(Layout, { children: _jsxs(Layout.Section, { children: [_jsx(LegacyCard, { sectioned: true, children: _jsx(SkeletonBodyText, {}) }), _jsx(LegacyCard, { sectioned: true, children: _jsxs(TextContainer, { children: [_jsx(SkeletonDisplayText, { size: "small" }), _jsx(SkeletonBodyText, {})] }) }), _jsx(LegacyCard, { sectioned: true, children: _jsxs(TextContainer, { children: [_jsx(SkeletonDisplayText, { size: "small" }), _jsx(SkeletonBodyText, {})] }) })] }) }) })) : (_jsx(Page, { title: "Install on your Shopify store", children: _jsx(Box, { children: _jsx(Form, { onSubmit: handleInstallApp, children: _jsx(FormLayout, { children: _jsxs(Card, { children: [_jsx(Text, { variant: "headingSm", as: "h2", children: "Your shop URL" }), _jsx(Box, { children: _jsx(TextField, { label: "" // Add a label for accessibility
                                    , placeholder: "i.e. your-shop.myshopify.com", value: data.shop, onChange: function (value) { return setData(function (prevData) { return (__assign(__assign({}, prevData), { shop: value })); }); }, helpText: "Input your Shopify store subdomain URL to install the app. Example: shop-url.myshopify.com", autoComplete: "off" // Optional, depending on your needs
                                 }) }), _jsx(InlineStack, { align: "end", children: _jsx(Button, { onClick: handleInstallApp, children: "Install" }) })] }) }) }) }) }));
};
export default Home;
